export class UserWiseModuleColumn {
    Id: number;
    UserInfoId: number;
    ModuleId: number;
    ColumnName: string;
    UserPreferencesDisplayOrder: number;
    IsActive: boolean;
}